<template>
  <v-card tile elevation="0">
    <v-card-title>コントローラ</v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col md="4" cols="12">
          <text-field-like
              :value="controller.name"
              label="コントローラ名"
              hide-details>
          </text-field-like>
        </v-col>
        <v-col md="4" cols="12">
          <text-field-like
              :value="controllerStatus[controller.status]"
              label="ステータス"
              hide-details>
          </text-field-like>
        </v-col>
        <v-col cols="12">
          <text-field-like
              :value="controller.description"
              label="説明"
              placeholder="未設定"
              hide-details
              multi-line>
          </text-field-like>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {CONTROLLER_STATUSES} from "@/constants";
export default {
  name: 'ControllerInfo',
  components: {TextFieldLike},
  props: {
    controller: {
      type: Object,
      required: true
    }
  },
  computed: {
    controllerStatus: () => CONTROLLER_STATUSES,
  }
}
</script>
